// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandy_shocks: PokeData = {
  "id": 989,
  "name": "sandy-shocks",
  "height": 23,
  "weight": 600,
  "base_experience": 285,
  "types": [
    PokeType.ELECTRIC,
    PokeType.GROUND
  ],
  "api_moves": [
    "supersonic",
    "thunder-shock",
    "thunder-wave",
    "screech",
    "tri-attack",
    "zap-cannon",
    "spark",
    "mirror-coat",
    "metal-sound",
    "gravity",
    "earth-power",
    "discharge",
    "charge-beam",
    "heavy-slam",
    "bulldoze",
    "magnetic-flux",
    "electric-terrain"
  ],
  "moves": [
    "supersonic",
    "thunder-shock",
    "tri-attack",
    "zap-cannon",
    "metal-sound",
    "earth-power",
    "electric-terrain",
    "volt-switch",
    "quick-tempo",
    "fissure",
    "volt-crash",
    "rototiller",
    "thunderbolt"
  ],
  "evolution_chain": {
    "id": 520,
    "item": null,
    "species": [
      {
        "name": "sandy-shocks",
        "order": 981,
        "types": [
          PokeType.ELECTRIC,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 130,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
